module.exports = __webpack_public_path__ + "media/images/dd-2a4ebeea6b2e2bf0de3c2d5c6b877296.png";